<template>
    <teleport to="#modal">
    </teleport>
    <div class="m-auto px-8 pb-8">
        <div class="m-auto pt-5">
            <h2 class="text-3xl font-bold mb-4">Dettaglio Odv</h2>

            <table class="border-collapse w-full">

                <thead>
                <tr>
                    <th class="bg-white border-2 px-2">Tipo documento</th>
                    <th class="bg-white border-2 px-2">Creazione</th>
                    <th class="bg-white border-2 px-2">Variazione</th>
                    <th class="bg-white border-2 px-2">Numero</th>
                    <th class="bg-white border-2 px-2">Data</th>
                    <th class="bg-white border-2 px-2">Progetto</th>
                    <th class="bg-white border-2 px-2">Nodo</th>
                    <th class="bg-white border-2 px-2" colspan="2">Descrizione</th>
                    <th class="bg-white border-2 px-2">Cliente</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td class="whitespace-nowrap px-2">{{ odv?.TIPODOCUMENTO }}</td>
                    <td class="whitespace-nowrap px-2">{{ odv?.UTENTEINSERIMENTO }}</td>
                    <td class="whitespace-nowrap px-2">{{ odv?.UTENTEVARIAZIONE }}</td>
                    <td class="whitespace-nowrap px-2">{{ odv?.NUMDOC }}</td>
                    <td class="whitespace-nowrap px-2">{{ $filters.toDate(odv?.DATADOC) }}</td>
                    <td class="whitespace-nowrap px-2">{{ odv?.PROGETTO }}</td>
                    <td class="whitespace-nowrap px-2">{{ odv?.NODO }}</td>
                    <td class="whitespace-nowrap px-2">{{ odv?.DESCRIZIONENODO }}</td>
                    <td class="whitespace-nowrap px-2">{{ odv?.CLIENTE }}</td>
                </tr>
                </tbody>
                <thead>

                <tr>
                    <th colspan="2" class="bg-white border px-2">Ragione Sociale</th>
                    <th colspan="2" class="bg-white border px-2">Partita IVA</th>
                    <th class="bg-white border px-2">Valuta</th>
                    <th class="bg-white border px-2">Cambio</th>
                    <th class="bg-white border px-2">Imponibile</th>
                    <th class="bg-white border px-2">Totale</th>
                    <th class="bg-white border px-2">Totale trasformato</th>
                    <th class="bg-white border px-2">Totale residuo</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td colspan="2" class="whitespace-nowrap px-2">{{ odv?.RAGSOC }}</td>
                    <td colspan="2" class="whitespace-nowrap px-2">{{ odv?.PARTITAIVA }}</td>
                    <td class="whitespace-nowrap px-2">{{ odv?.VALUTA }}</td>
                    <td class="whitespace-nowrap px-2">{{ odv?.CAMBIO }}</td>
                    <td class="whitespace-nowrap px-2">{{  $filters.toCurrency(odv?.TOATLEIMPONIBILE) }}</td>
                    <td class="whitespace-nowrap px-2">{{  $filters.toCurrency(odv?.TOTALEDOCUMENTO) }}</td>
                    <td class="whitespace-nowrap px-2">{{  $filters.toCurrency(odv?.totale_trasformato) }}</td>
                    <td class="whitespace-nowrap px-2">{{  $filters.toCurrency(odv?.totale_residuo) }}</td>
                </tr>
                </tbody>
            </table>

            <div class="flex flex-col col-span-2 mb-2 pt-3">
                <Field field_name="Cerca" @update:modelValue="lista.debounceSearch"
                       v-model="lista.search"
                       placeholder="Cerca"></Field>
            </div>

            <div class="flex justify-end">
                <Paginator class="" :pagination="lista.paginate"></Paginator>
            </div>

            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 border-separate border-spacing-3 py-4"
                           v-model:cols="cols"
                           :rows="lista.rows" @order-update="lista.updateCols">

                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_2`]="context">
                        {{ $filters.toFormat(c[cols[2].prop], 0, 0) }}
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_3`]="context">
                        {{ $filters.toCurrency(c[cols[3].prop]) }}
                    </template>

                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                        {{ $filters.toEuroCurrency(c[cols[4].prop]) }}
                    </template>

                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_6`]="context">
                        {{ $filters.toEuroCurrency(c[cols[6].prop]) }}
                    </template>

                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_7`]="context">
                        {{ $filters.toEuroCurrency(c.IMPORTO_EURO - c.VALORETRASFORMATO) }}
                    </template>

                </NextTable>
            </div>

            <InfiniteLoading @infinite="lista.fetchNextPage"
                             :identifier="lista.infiniteIdentifier" style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altre righe.</div>
                </template>
            </InfiniteLoading>

        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";
import Modal from "@/components/Modal.vue";
import Loading from "@/components/Loading.vue";
import Field from "@/components/Field.vue";
import Paginator from "@/components/Paginator.vue";
import NextTable from "@/components/NextTable.vue";
import InfiniteLoading from "v3-infinite-loading";
import Lista from "@/setup/ListaCerca";
import odvManager from "@/api/Odv";

@Options({
    name: 'DettaglioOdv',
    components: {NextTable, Paginator, Field, InfiniteLoading, Loading, Modal, NextButton},
    props: {
        ditta: [Number, String],
        n_reg: [Number, String],
    },
    computed: {},
    methods: {}
})
export default class DettaglioOdv extends Vue {
    lista: any = setup(() => Lista(odvManager, this.cols, odvManager.righeOdvGamma));
    ditta!: string;
    n_reg!: string;
    odv = {}

    created() {
        odvManager.dettaglioOdvGamma(this.ditta, this.n_reg).then((res) => {
            this.odv = res.data
        })
        this.lista.callBinds = [this.ditta, this.n_reg]
        this.lista.sort = 'PROGRIGA'
        this.lista.fetchData()
    }


    cols = [
        {
            name: 'N°',
            prop: 'PROGRIGA',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Descrizione',
            prop: 'DESCARTICOLO',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Q.tà',
            prop: 'QTA',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Importo',
            prop: 'PREZZO',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Totale imponibile',
            prop: 'IMPORTO_EURO',
            orderable: true,
            class: '',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Iva',
            prop: 'ALIQIVA',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'whitespace-nowrap text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Valore trasformato imponibile',
            prop: 'VALORETRASFORMATO',
            orderable: true,
            class: '',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Valore residuo imponibile',
            prop: 'VALORERESIDUO',
            orderable: true,
            class: '',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Nodo',
            prop: 'NODO',
            orderable: true,
            class: '',
            td_class: 'whitespace-nowrap text-right px-2 bg-next-gray-md-dark',
            resizable: true
        }
    ]
}

</script>


<style lang="scss" scoped>
.table-costi-ricavi {
    td {
        @apply p-2 text-sm relative bg-next-gray-md-dark
    }
}
</style>
